<div class="row g-3">
  @for (type of revised_features | keyvalue: disable_sort; track type) {
    @if (type.value.length) {
      <div class="col col-12">
        <div class="card shadow-sm">
          <div class="card-body">
            <h4 class="card-title mb-3">{{ type.key | translate }}</h4>
            <div class="row g-3">
              @for (feature of type.value; track feature) {
                <div class="col col-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row d-flex">
                        <div class="col">
                          <h5 class="line-clamp-2 text-break">{{ feature.name }}</h5>
                          @if (feature.description) {
                            <button
                              class="btn btn-link neutral-btn text-capitalize fw-light text-decoration-underline focus-visible"
                              (click)="viewDetails(feature)"
                            >
                              {{ 'view_details' | translate }}
                            </button>
                          }
                        </div>
                        <div class="col col-auto text-end">
                          <div class="d-flex gap-4">
                            <div>
                              <h5
                                class="mb-0"
                                [class.text-decoration-line-through]="
                                  feature.sub_type === 'REMOVED_FEATURE'
                                "
                              >
                                {{ feature.monthly_cost_to_currency }}
                              </h5>
                              <small class="text-secondary">
                                {{ 'per_month' | translate }}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
